// extracted by mini-css-extract-plugin
var _1 = "Table-moduletableWrapper__leA3C";
export { _1 as "tableWrapper" }
